import React from 'react';

export const OzobotSvg = ({style, className, draggable, onDragStart, onDragEnd}) =>
    <div style={style} className={className} draggable={draggable} onDragStart={onDragStart} onDragEnd={onDragEnd} onClick={e => e.stopPropagation()}>
        <svg xmlns="http://www.w3.org/2000/svg" width="1.23178in" height="1.23178in" version="1.1"
             viewBox="0 0 1231.78 1231.78">
            <defs>
            </defs>
            <g id="Layer_x0020_1">
                <metadata id="CorelCorpID_0Corel-Layer"/>
                <g id="_2006361511744">
                    <path className="fil0"
                          d="M615.89 0c340.15,0 615.89,275.74 615.89,615.89 0,340.15 -275.74,615.89 -615.89,615.89 -340.15,0 -615.89,-275.74 -615.89,-615.89 0,-340.15 275.74,-615.89 615.89,-615.89zm0 158.02c252.88,0 457.87,205 457.87,457.87 0,252.88 -205,457.87 -457.87,457.87 -252.88,0 -457.87,-205 -457.87,-457.87 0,-252.88 205,-457.87 457.87,-457.87z"/>
                    <circle className="fil1" cx="1152.74" cy="623.48" r="55.89"/>
                    <path className="fil2"
                          d="M615.89 158.02c252.88,0 457.87,205 457.87,457.87 0,252.88 -205,457.87 -457.87,457.87 -252.88,0 -457.87,-205 -457.87,-457.87 0,-252.88 205,-457.87 457.87,-457.87z"/>
                    <polygon className="fil0" points="1143.85,589.94 1177.39,623.48 1143.85,657.02 "/>
                    <circle className="fil3" transform="matrix(1.46733 -0.847163 0.847163 1.46733 1084.25 354.704)"
                            r="32.99"/>
                    <circle className="fil3" transform="matrix(1.46733 0.847163 -0.847163 1.46733 1076.66 891.559)"
                            r="32.99"/>
                </g>
            </g>
        </svg>
    </div>;



// WEBPACK FOOTER //
// ./src/Simulator/Ozobot/OzobotSvg.js